import React from 'react';
import { InsideDiv, StyledGrandDiv, StyledText } from './styles';
import UserAvatar from '../UserAvatar';
import { useSelector } from 'react-redux';
import { BellComponent } from '../../Notifications/BellComponent';
import { notificationNavigateDashboard } from '../../Notifications/BellComponent/utils';

const TopBar = ({ text }) => {
  const user = useSelector((state) => state.auth.user);

  const redirectionTopBarFunctions = {
    "task_mention": notificationNavigateDashboard
  }


  return (
    <StyledGrandDiv>
      <InsideDiv>
        <StyledText>{text}</StyledText>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BellComponent redirectionFunctions={redirectionTopBarFunctions} style={{ marginRight: '1rem' }} />
          <UserAvatar user={user} />
        </div>
      </InsideDiv>
    </StyledGrandDiv>
  );
};

export default TopBar;
